module.exports = __webpack_public_path__ + "static/media/roman.68d791f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Testimonial/roman.jpg
// module id = 91
// module chunks = 0